import React from 'react';
const chips = ['No forms to fill', 'Refunded to your original payment method', 'Keep the bonuses'];
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="topo-dark w-full bg-forest" data-id="element-109" data-mp="1o5q1qgnuw7zz">
      <div className="mx-auto max-w-3xl px-5 py-14 text-center sm:py-20" data-id="element-110" data-mp="221bvf151bfyq">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full border-[3px] border-dashed border-ember text-ember" data-id="element-111" data-mp="1x4uxxgby3p8z">
          <span className="font-display text-5xl leading-none" data-id="element-112" data-mp="14fxtoh4kjsz8">7</span>
          <span className="text-xs font-bold uppercase tracking-widest" data-id="element-113" data-mp="14dl53l4b2kd7">Days</span>
        </div>
        <p className="eyebrow mt-6 text-ember" data-id="element-114" data-mp="1j6n7zsdbto7b">Zero risk</p>
        <h2 id="guarantee-heading" className="trail-underline mt-3 font-display text-[34px] leading-tight text-paper sm:text-6xl" data-id="element-115" data-mp="1ecsooq1mvb8r">
          Open everything. Take it on your next call.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-paper/80" data-id="element-116" data-mp="lowld2hk6l30">
          Read the volumes, pull up a card on your next service call, fill in a
          worksheet. If Solar PV &amp; Battery Diagnostic Pro doesn&apos;t change
          how you diagnose and close a call, email us within 7 days and you get
          every cent back.
        </p>
        <ul className="mt-7 flex flex-wrap justify-center gap-2.5" data-id="element-117" data-mp="12rg3mo1kvklj">
          {chips.map(chip => <li key={chip} className="rounded-full border border-paper/25 px-4 py-2 text-[13px] text-paper/80" data-id="element-118" data-mp="61ffmr91985a">
              {chip}
            </li>)}
        </ul>
      </div>
    </section>;
}